import React, { useState } from "react";

import LoginForm from "./LoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

function Form() {
  const [pageType, setPageType] = useState("login");

  return (
    <>
      {pageType === "login" ? (
        <LoginForm setPageType={setPageType} />
      ) : (
        <ForgotPasswordForm handleBackToLogin={() => setPageType("login")} />
      )}
    </>
  );
}

export default Form;
